import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbProfessionalAccounts = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>
                Professional Accounts - Raw Speed. Ultra-Low Spreads. Pro-Grade
                Execution.
              </h1>
              <p>
                When every millisecond matters and every pip counts,
                Professional Accounts give you the firepower to trade like a
                market veteran. Designed for advanced strategies, high-volume
                flows, and traders who demand an edge, this is where real
                precision trading begins.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Trading Forex
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbProfessionalAccounts.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbProfessionalAccounts;
